export class TruckerItem {
    customerId: number = 0;
    customerName: string = '';
    city: string = '';
    customerCode: string = '';
    executedLoads: number = 0;
    totalLoads: number = 0;

    isSelected: boolean = false;
}
